import React from "react";
import { LADDER } from "../../data";
import SectionHead from "./SectionHead";
import { ArrowUp } from "lucide-react";

export default function SkillLadder() {
  return (
    <section className="sec" style={{ background: "#00030F", borderTop: "1px solid var(--line)", borderBottom: "1px solid var(--line)" }}>
      <div className="mx-auto max-w-[1080px] px-4 lg:max-w-[1440px] lg:px-12">
        <SectionHead index={LADDER.index} title={LADDER.title} center />
        <p className="mt-5 mx-auto max-w-[60ch] text-center" style={{ fontSize: "1.08rem" }}>
          Non è una questione di quanto fatturi.<br />
          È una questione di che livello vedi in una trattativa.
        </p>

        <div className="mt-12 relative">
          <div className="grid gap-5 md:grid-cols-2 items-stretch">
            {LADDER.steps.map((s, i) => {
              const active = i === 1;
              return (
                <div
                  key={i}
                  className="panel p-8 relative"
                  style={active ? { borderColor: "rgba(46,107,255,0.6)", boxShadow: "0 0 40px rgba(46,107,255,0.18)" } : {}}
                >
                  <div className="flex items-center justify-between">
                    <span className="kicker" style={{ color: active ? "var(--blue-2)" : "var(--muted)" }}>{s.level}</span>
                    <span className="display" style={{ fontSize: "1.05rem", color: active ? "var(--blue-2)" : "var(--muted)" }}>{s.range}</span>
                  </div>
                  <h3 className="display mt-4" style={{ fontSize: "2rem", fontStyle: "normal", color: active ? "#fff" : "var(--ink)" }}>
                    {i === 0 ? (
                      <>Ne sai tanto del <em style={{ fontStyle: "italic" }}>prodotto/nicchia.</em></>
                    ) : (
                      <>Ne sai tanto delle <em style={{ fontStyle: "italic" }}>persone</em> ed i loro <em style={{ fontStyle: "italic" }}>limiti</em></>
                    )}
                  </h3>
                  <p className="mt-4" style={{ fontSize: "1rem" }}>{s.body}</p>
                </div>
              );
            })}
          </div>

          <div className="hidden md:flex absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full" style={{ width: 54, height: 54, background: "var(--blue)", boxShadow: "0 0 30px rgba(46,107,255,0.6)" }}>
            <ArrowUp className="text-white" size={26} style={{ transform: "rotate(90deg)" }} />
          </div>
        </div>

        <div className="mt-12 text-center">
          <p className="display" style={{ fontSize: "clamp(1.5rem, 4vw, 2.4rem)" }}>
            Ti porto dal livello <span className="blue">prodotto</span> al livello <span className="blue">persona</span>.
          </p>
          <p className="mx-auto mt-5 max-w-[62ch]" style={{ fontSize: "1rem" }}>{LADDER.note}</p>
          <p className="v-serif mx-auto mt-12 max-w-[62ch]" style={{ fontSize: "clamp(1.3rem, 3.4vw, 1.9rem)", lineHeight: 1.3, fontWeight: 400, color: "var(--ink)" }}>{LADDER.processNote}</p>
        </div>
      </div>
    </section>
  );
}
